export default __webpack_public_path__ + "static/custom-software-development-company-peerbits-544b88ef529a3c69de2352e0c60a29e2.png";